<template>
    <div id="upload" class="shadow" v-show="isCategory('upload')">
        <div class="columns">
            <div class="column col-6">
                <picture-input
                        width="600"
                        height="400"
                        margin="16"
                        accept="image/jpeg,image/png"
                        size="10"
                        :crop="false"
                        button-class="btn"
                        :custom-strings="{
                        upload: '<h1>Bummer!</h1>',
                        drag: 'Extraoral'
                      }"
                        @change="onExtraOralImageChange">
                </picture-input>
            </div>
            <div class="column col-6">
                <picture-input
                        width="600"
                        height="400"
                        margin="16"
                        accept="image/jpeg,image/png"
                        size="10"
                        :crop="false"
                        button-class="btn"
                        :custom-strings="{
                        upload: '<h1>Bummer!</h1>',
                        drag: 'Intraoral'
                      }"
                        @change="onIntraOralImageChange">
                </picture-input>
            </div>
        </div>
    </div>
</template>

<script>
import PictureInput from 'vue-picture-input'
import { CANVAS_WIDTH, CANVAS_HEIGHT } from "@/components/smile/SmileDesign"

export default {
    name: "Upload",
    components: {
        PictureInput,
    },
    methods: {
        isCategory(name) {
            return this.$store.getters.isCategory(name)
            // return true
        },

        // Upload event listeners
        onExtraOralImageChange (imageString) {
            if (imageString) {
                const image = new Image()
                image.onload = () => {
                    const scale = Math.min(CANVAS_WIDTH / image.width, CANVAS_HEIGHT / image.height) * 0.8

                    let extraOral = {}
                    extraOral.image = image
                    extraOral.x = (CANVAS_WIDTH - image.width * scale) / 2
                    extraOral.y = CANVAS_HEIGHT * 0.1
                    extraOral.rotation = 0
                    extraOral.scaleX = scale
                    extraOral.scaleY = scale

                    this.$store.commit("updateExtraOralImage", extraOral)
                }
                image.src = imageString
            } else {
                // eslint-disable-next-line no-console
                console.log('FileReader API not supported: use the <form>, Luke!')
            }
        },

        onIntraOralImageChange (imageString) {
            if (imageString) {
                const image = new Image()
                image.onload = () => {
                    const scale = Math.min(CANVAS_WIDTH * 0.33 / image.width, CANVAS_HEIGHT * 0.25 / image.height)

                    let intraOral = {}
                    intraOral.image = image
                    intraOral.x = CANVAS_WIDTH * 0.5 - (image.width * scale) / 2
                    intraOral.y = CANVAS_HEIGHT * 0.625
                    intraOral.rotation = 0
                    intraOral.scaleX = scale
                    intraOral.scaleY = scale
                    this.$store.commit("updateIntraOralImage", intraOral)
                }
                image.src = imageString
            } else {
                // eslint-disable-next-line no-console
                console.log('FileReader API not supported: use the <form>, Luke!')
            }
        },
    }
}
</script>

<style scoped>

</style>